import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext.js';
import { db } from '../../firebase/firebase.js';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import {setFirestoreData} from '../../firebase/Firestore.js';
import './SubmitAbstract.css';
import DeleteAbstract from './DeleteAbstract.js';



const ViewSubmission = () => {
  const { currentUser } = useAuth();
  const [abstracts, setAbstracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [presentationTypes, setPresentationTypes] = useState({
  poster: false,
  presentation: false,
  });

const handlePresentationTypeChange = async (e) => {
  const { name, checked } = e.target;

  // 1️⃣ Update local state
  setPresentationTypes((prev) => {
    const newState = { ...prev, [name]: checked };

    // 2️⃣ Update Firestore with the new state
    const userStatusUpdate = {
      poster_pref: newState.poster,
      presentation_pref: newState.presentation,
    };

    // Fire-and-forget async call
    setFirestoreData("Users", currentUser.uid, userStatusUpdate, true)
      .then(() => console.log("Firestore updated"))
      .catch((err) => console.error("Error updating Firestore:", err));

    return newState; // Update local state
  });
};


  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/sculc/submit-abstract'); // Navigates to the SubmitAbstract page.
  };

  const handleDeleteSubmission = async (index) => {
    if (!currentUser) return;
  
    try {
      await DeleteAbstract(currentUser.uid, index); // Pass userId and index to DeleteAbstract
      alert("Your submission has been deleted.");
  
      // Optimistically update the local state to reflect deletion
      setAbstracts((prevAbstracts) => prevAbstracts.filter((_, i) => i !== index));
    } catch (error) {
      console.error("Error deleting submission:", error);
      alert("Failed to delete the submission. Please try again.");
    }
  };



  useEffect(() => {
    const fetchSubmissionDetails = async () => {
      if (!currentUser) return;

      try {
        const userDoc = await getDoc(doc(db, "Users", currentUser.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();

          // 1️⃣ Set abstracts
          const abstractFiles = userData?.abstracts || [];
          setAbstracts(abstractFiles);

          // 2️⃣ Set presentationTypes based on Firestore booleans
          setPresentationTypes({
            poster: !!userData.poster_pref,          // convert undefined/null to false
            presentation: !!userData.presentation_pref,
          });

          console.log("Fetched user data:", userData);
        } else {
          console.log("No user data found");
        }
      } catch (error) {
        console.error("Error fetching submission details:", error);
      }

      setLoading(false);
    };

    fetchSubmissionDetails();
  }, [currentUser]);



  if (loading) return <p>Loading...</p>;

  return (
    <div className="view-submission-page">
      <div className="view-submission-container">
        <p className="submission-header">Thank You for Your Submission</p>



        <div className="presentation-type-section">
          <p className="presentation-selection">Select the type of presentations you'd like to be considered for below:</p>
          
          <div className="presentation-options">
            <label className="flex items-center gap-2 mt-2">
              <input
                type="checkbox"
                name="poster"
                checked={presentationTypes.poster}
                onChange={handlePresentationTypeChange}
              />
              Poster
            </label>

            <label className="flex items-center gap-2 mt-2">
              <input
                type="checkbox"
                name="presentation"
                checked={presentationTypes.presentation}
                onChange={handlePresentationTypeChange}
              />
              Presentation
            </label>
          </div>
        </div>

                {/* Render buttons for each submission */}
        {abstracts.length > 0 ? (
          <div className="button-group">
            {abstracts.map((submission, index) => (
              <div key={index} className="submission-item">
                <button
                  onClick={() => window.open(submission.url, "_blank", "noopener,noreferrer")}
                  className="view-submission-button"
                >
                  {submission.name || `View Submission ${index + 1}`}
                </button>
                <button
                  onClick={() => handleDeleteSubmission(index)}
                  className="delete-submission-button"
                  title="Delete Submission" // Tooltip for accessibility
                >
                  × {/* The "x" symbol */}
                </button>
              </div>
            ))}
          </div>
        ) : (
          <p>No submissions found. Please ensure your submission was successful.</p>
        )}
        <p className="submission-message">
          Your abstract is currently being processed. <br />
          We will contact you if there are any updates to your submission status.<br />
        </p>

        <button onClick={handleNavigate} className="submit-abstract-button">
          Upload Another Abstract
        </button>
      </div>
    </div>
  );
};

export default ViewSubmission;
